import {db} from "../Database/handwaiDB.js";


export function setAdviceDB(advice) {
    (async () => {
        try {
            await db.advices.put({
                advicesUID: advice.uidid,
                data: advice
            });
        } catch (error) {
            console.log(error);
        }
    })();

}

export function setAllAdvicesDB(advices) {
    (async () => {
        try {
            for (let obj of advices) {
                await db.advices.put({
                advicesUID: obj.uidid,
                data: obj
            });}

        } catch (error) {
            console.log(error);
        }
    })();

}



export async function getAdviceDB(adviceID) {
    let result;

    try {
        const result1 = await db.advices.where("advicesUID").equals(adviceID).toArray(
            function (advices) {
                result = JSON.stringify(advices)
                return result;
            }
        );

        return JSON.parse(result1.toString())

    } catch (error) {
        console.log(error);
    }
}

export async function getAllAdvicesDB() {

    let result;

    try {
        const result1 = await db.advices.toArray(
            function (advices) {
                result = JSON.stringify(advices)
                return result;
            }
        );

        return JSON.parse(result1.toString())

    } catch (error) {
        console.log(error);
    }
}



export function removeAdviceDB(adviceID) {
    (async () => {
        try {
            await db.advices.delete(adviceID);
        } catch (error) {
            console.log(error);
        }
    })();

}